import React from "react";
import Navbar from "../../components/layout/Navbar/Navbar";
import Footer from "../../components/layout/Footer/Footer";
import "./Safety.css";

type Precaution = { precaution: string };

type Group = {
  title: string;
  precautions: Precaution[];
};

const safetyGroups: Group[] = [
  {
    title: "Before You Accept",
    precautions: [
      { precaution: "Do not accept a meal if the tamper seal is broken" },
      { precaution: "Confirm the identity of the delivery person before accepting the food" },
      { precaution: "Ensure hot foods are delivered hot, and cold foods are appropriately chilled" },
      { precaution: "Choose a secure delivery location, especially for high-value orders" },
    ],
  },
  {
    title: "Inspect What You Receive",
    precautions: [
      { precaution: "Examine the packaging for any damage, leaks, or unusual odors" },
      { precaution: "Inspect packaged items for expiry dates" },
      {
        precaution:
          "If the food looks, smells, or tastes unusual, refrain from consuming it and report the issue immediately",
      },
    ],
  },
  {
    title: "Payments, Allergies & Reporting",
    precautions: [
      { precaution: "Communicate any allergies or dietary restrictions clearly to the vendor" },
      {
        precaution:
          "Use secure and trusted payment methods provided by the app to protect your financial information",
      },
      {
        precaution:
          "If you encounter any problems or suspect food safety issues, report them promptly to the app's customer support",
      },
      {
        precaution:
          "Take pictures of any discrepancies or issues with the delivered food as evidence in case of disputes",
      },
      {
        precaution:
          "Ensure your food delivery app is always up to date. Regular updates may include new safety features or important information",
      },
    ],
  },
];

const Safety: React.FC = () => {
  let counter = 0;

  return (
    <div className="safety-page-root">
      <Navbar />
      <main className="safety-container">
        <header className="safety-hero">
          <span className="section-label">Guidelines</span>
          <h1 className="safety-title">Food Safety & Delivery Guidelines</h1>
          <p className="safety-subtitle">
            How to inspect and handle delivered meals to keep you and your
            community safe.
          </p>
        </header>

        <section className="safety-content">
          <p className="safety-intro">
            These quick checks help reduce risk and ensure you receive the
            food exactly as intended. If something looks off, please report
            it through the app so we can take action.
          </p>

          {safetyGroups.map((group) => (
            <div className="safety-group" key={group.title}>
              <h2 className="safety-group-title">{group.title}</h2>

              <ol className="safety-list" aria-label={group.title}>
                {group.precautions.map((p) => {
                  counter += 1;
                  return (
                    <li key={p.precaution} className="safety-item">
                      <span className="safety-number">
                        {String(counter).padStart(2, "0")}
                      </span>
                      <span className="safety-text">{p.precaution}</span>
                    </li>
                  );
                })}
              </ol>
            </div>
          ))}

          <p className="safety-note">
            If you experience any issues, tap <strong>Support</strong> in the
            app and provide order details and any photos. This helps us
            resolve problems quickly.
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Safety;
